import { FirebaseConfig, SecondaryFirebaseConfig } from "../config";

/**
 * Firebase, loaded on first use. NACA-Core serves most communities now, so the
 * Firebase SDK (a large download) is only fetched when a sheet falls back to
 * Firestore, or for a community with a secondary (Benhti) dataset.
 */
let loading = null;

const loadFirestore = () => {
  if (!loading) {
    loading = Promise.all([
      import("firebase/app"),
      import("@firebase/firestore"),
    ]).then(([{ initializeApp }, firestore]) => {
      const open = (config, name) =>
        firestore.initializeFirestore(initializeApp(config, name), {
          experimentalAutoDetectLongPolling: true,
        });
      return {
        firestore,
        db: open(FirebaseConfig),
        dbSecondary: SecondaryFirebaseConfig
          ? open(SecondaryFirebaseConfig, "secondary")
          : null,
      };
    });
  }
  return loading;
};

/** Whether this community has a secondary (Benhti) Firestore. */
export const HAS_SECONDARY = Boolean(SecondaryFirebaseConfig);

/**
 * Every document in a Firestore collection.
 *
 * @param {string} collectionName
 * @param {{secondary?: boolean}} [options] - Read the secondary project
 * @returns {Promise<Array<{id: string, data: Function}>>} Firestore's docs
 */
export const getFirestoreDocs = async (collectionName, { secondary } = {}) => {
  const { firestore, db, dbSecondary } = await loadFirestore();
  const snap = await firestore.getDocs(
    firestore.collection(secondary ? dbSecondary : db, collectionName),
  );
  return snap.docs;
};
